module.exports = __webpack_public_path__ + "img/J11871.c04b2c96.png";